const ROUTER_DOMAIN = 'router'
const ROUTER_STATE = {
  location: {},
  action: ''
}

export {
  ROUTER_DOMAIN,
  ROUTER_STATE
}
